module.exports = __webpack_public_path__ + "static/media/soils_example_2_2.7b509b18.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_example_2_2.png
// module id = 1283
// module chunks = 0